import styled from "styled-components";

export const SocialNetworksContainer = styled.div`
  display: flex;
  padding-top: 12px;
  gap: 16px;
`;
